(function ($) {
    // USE STRICT
    "use strict";

    $(document).ready(function() {
        $('.match-item').matchHeight({

        });
    });

})(jQuery);